




















import { defineComponent, onMounted } from '@vue/composition-api';
import HeaderModule from '@/components/header-module/index.vue';
import NgoStampModule from '@/components/ngo-stamp-module/index.vue';
import NewsModule from '@/components/news-module/index.vue';
import Footer from '@/components/footer-module/index.vue';
import PageTab from '@/components/page-tab/index.vue';
import { biBrow } from '@tencent/fit-bi-sdk';
import NineDayTipDialog from '@/components/nine-day/act-tip-dialog.vue';

export default defineComponent({
  name: 'home',
  components: {
    HeaderModule,
    NgoStampModule,
    NewsModule,
    Footer,
    PageTab,
    NineDayTipDialog,
  },
  setup() {
    onMounted(() => {
      biBrow('home.page_brow|首页曝光');
    });
    return {
    };
  },
});
